
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/captions",
      function () {
        return require("private-next-pages/captions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/captions"])
      });
    }
  